import Scorecard from "./Scorecard";

export default Scorecard;
